var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3349 5.33176L8.67714 4.9455L7.48907 2.53691C7.45662 2.47097 7.40324 2.41758 7.33729 2.38513C7.1719 2.30349 6.97093 2.37152 6.88823 2.53691L5.70016 4.9455L3.04245 5.33176C2.96917 5.34222 2.90218 5.37677 2.85089 5.4291C2.78888 5.49284 2.75471 5.57858 2.75589 5.6675C2.75707 5.75641 2.79349 5.84122 2.85717 5.90329L4.78006 7.77803L4.32577 10.4253C4.31512 10.4869 4.32193 10.5502 4.34544 10.6081C4.36895 10.666 4.40821 10.7162 4.45878 10.7529C4.50935 10.7896 4.56919 10.8114 4.63153 10.8159C4.69387 10.8203 4.7562 10.8072 4.81147 10.778L7.18865 9.52821L9.56584 10.778C9.63074 10.8126 9.70611 10.8241 9.77833 10.8115C9.96047 10.7801 10.0829 10.6074 10.0515 10.4253L9.59724 7.77803L11.5201 5.90329C11.5725 5.85199 11.607 5.785 11.6175 5.71173C11.6457 5.52855 11.518 5.35897 11.3349 5.33176Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e3fd96dcadf450b27c24c21e0c9c7356.svg";
export { ForwardRef as ReactComponent };